<div class="description-container">
  @if (!isEditing) {
  <div class="description-display" [class.placeholder]="!description" (click)="onDisplayClick($event)">
    @if (description) {
    <div [innerHTML]="resolvedDescription"></div>
    } @else {
    <span class="placeholder-text">Add a description...</span>
    }
  </div>
  } @else {
  <app-rich-text-field
    [value]="descriptionDraft"
    [projectId]="projectId"
    [workspaceId]="workspaceId"
    [nodeInstanceId]="nodeInstanceId"
    [attachmentDialogContext]="'node'"
    [imageNamePrefix]="nodeKey"
    [autoFocus]="true"
    placeholder="Add details with formatting..."
    (valueChange)="onDraftChange($event)"
    (blur)="onEditorBlur($event)"></app-rich-text-field>
  }
</div>
